export default "__VITE_ASSET__DJ52l_Bh__"